/**
 * Mode debug E2E / staging (bandeau IDs sur l’admin).
 * Désactivé par défaut : activer explicitement avec `VITE_E2E_MODE=true` ou `1`
 * dans `.env` / `.env.local` (dev) ou au build (staging).
 */
export function isE2EStagingMode(): boolean {
  const v = String(import.meta.env.VITE_E2E_MODE ?? "").trim().toLowerCase();
  return v === "true" || v === "1";
}
